<template>
	<div class="echarts">
		<v-chart :options="option" />
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import 'echarts/lib/chart/bar'
	import 'echarts/lib/component/tooltip'
	import 'echarts/lib/component/legend'
	import 'echarts/lib/component/title'
	export default {
		props: {
			datau: Object,
			colorType: {
				type: Number,
			},
		},
		components: {
			'v-chart': ECharts,
		},
		// watch:{
		//   datau(){

		//   }
		// },
		data: function() {
			let baseColor = '#fff'
			if (this.colorType == 2) {
				baseColor = '#333'
			}
			return {
				option: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					legend: {
						data: ['总隐患', '未整改隐患', '已整改隐患'],
						textStyle: {
							color: baseColor,
						},
					},
					grid: {
						left: 40,
						bottom: 60,
						top: 40,
						right: 40,
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: { show: true },
							dataView: { show: true, readOnly: false },
							magicType: { show: true, type: ['line', 'bar', 'stack'] },
							restore: { show: true },
							saveAsImage: { show: true },
						},
					},
					xAxis: [
						{
							type: 'category',
							axisTick: { show: false },
							data: this.datau.name,
							nameTextStyle: {
								color: baseColor,
							},
							nameRotate: 60,
							// x轴的字体样式
							axisLabel: {
								interval: 0,
								rotate: -15,
								show: true,
								textStyle: {
									color: baseColor,
									fontSize: '12',
								},
							},
							//x轴的颜色和宽度
							axisLine: {
								lineStyle: {
									color: baseColor,
								},
							},
						},
					],
					color: [
						'#0e9cff',
						'#fad514',
						'#21e0ba',
						'#21e74b',
						'#e40000',
						'#e77e21',
						'#ce91db',
						'#ade721',
						'#004af1',
						'#f100ee',
					],
					yAxis: [
						{
							type: 'value',

							splitLine: {
								show: false,
								//  改变轴线颜色
								lineStyle: {
									// 使用深浅的间隔色
									color: ['red'],
								},
							},
							//y轴的字体样式
							axisLabel: {
								show: true,
								textStyle: {
									color: baseColor,
								},
							},
							//y轴的颜色和宽度
							axisLine: {
								lineStyle: {
									color: baseColor,
									width: 1, //这里是坐标轴的宽度
								},
							},
						},
					],
					series: (() => {
						const list = this.datau.data
						let newList = []
						for (let item of list) {
							newList.push({
								name: item.name,
								type: 'bar',
								barGap: 0,
								emphasis: {
									focus: 'series',
								},
								lineStyle: {
									color: item.itemColor,
								},
								label: {
									show: true,
									position: 'top',
									textStyle: {
										color: baseColor,
									},
								},
								data: item.data,
							})
						}
						console.log(newList)
						return newList
					})(),
					// [
					//   {
					//     name: "总隐患数",
					//     type: "bar",
					//     barGap: 0,
					//     emphasis: {
					//       focus: "series",
					//     },
					//     label: {
					//       show: true,
					//       position: "top",
					//       textStyle: {
					//         color: baseColor,
					//       },
					//     },
					//     data: (() => {
					//       let list = [];
					//       for (let i = 0; i < this.datau.length; i++) {
					//         list.push(Math.ceil((Math.random() + 1) * 30));
					//       }
					//       return list;
					//     })(),
					//   },
					//   {
					//     name: "已整改",
					//     type: "bar",
					//     emphasis: {
					//       focus: "series",
					//     },
					//     lineStyle: {
					//       color: "#21e0ba",
					//     },
					//     label: {
					//       show: true,
					//       position: "top",
					//       textStyle: {
					//         color: baseColor,
					//       },
					//     },
					//     data: (() => {
					//       let list = [];
					//       for (let i = 0; i < this.datau.length; i++) {
					//         list.push(Math.ceil(Math.random() * 30));
					//       }
					//       return list;
					//     })(),
					//   },
					//   {
					//     name: "未整改",
					//     type: "bar",
					//     emphasis: {
					//       focus: "series",
					//     },
					//     lineStyle: {
					//       color: "#fad514",
					//     },
					//     label: {
					//       show: true,
					//       position: "top",
					//       textStyle: {
					//         color: baseColor,
					//       },
					//     },
					//     data: (() => {
					//       let list = [];
					//       for (let i = 0; i < this.datau.length; i++) {
					//         list.push(Math.ceil(Math.random() * 30));
					//       }
					//       return list;
					//     })(),
					//   },
					// ],
				},
			}
		},
	}
</script>

<style lang="scss" scoped>
	.echarts {
		width: 60vw;
		height: 96%;
		position: relative;
		top: 4%;
	}
</style>
